import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import pkg from '../../../package.json'
import dayjs from 'dayjs'

const env = process.env.REACT_APP_RUN_ENV

// @ts-ignore
// 防止多次wrapper

Sentry.init({
  dsn: 'https://372a5389d6a045059f8bf59ccb76e7d4@o168438.ingest.sentry.io/4504808398323712',
  integrations: [
    new BrowserTracing(),
    new Sentry.Integrations.Breadcrumbs({
      console: false,
    }),
  ],
  release: `${env}@${pkg.version}`,
  tracesSampleRate: 1.0,
  environment: env,
  beforeSend(event) {
    // TODO: 过滤敏感信息
    return event
  },
})

enum LevelEnum {
  DEBUG = 0,
  INFO = 1,
  WARNING = 2,
  ERROR = 3,
}

const levels: (keyof typeof LevelEnum)[] = ['DEBUG', 'INFO', 'WARNING', 'ERROR']

const colors = ['#439699', '#365216', '#bfa034', '#bb261a']

const trace = (level: LevelEnum, ...msgs: any[]) => {
  try {
    if (!msgs || msgs.length === 0) {
      return
    }
    if (level === LevelEnum.ERROR) {
      const [message, error] = msgs
      if (!error) {
        Sentry.captureMessage(message)
      } else {
        Sentry.addBreadcrumb({ message, level: 'info' })
        Sentry.captureException(error)
      }
    } else {
      const message = msgs
        .map(arg => {
          if (typeof arg === 'object') {
            return JSON.stringify(arg)
          }
          return arg.toString()
        })
        .join(' ')
      Sentry.addBreadcrumb({
        timestamp: Date.now() / 1000,
        message: message,
        level: (levels[level]?.toLowerCase?.() ?? 'info') as Sentry.SeverityLevel,
      })
    }
  } catch (err) {
    Sentry.addBreadcrumb({
      level: 'error',
      message: 'trace error',
    })
    Sentry.captureException(error)
  }
}

const log = (level: LevelEnum, ...msgs: any[]) => {
  const now = dayjs().format('HH:mm:ss')
  const args = [
    `%c [safeheron-web-console] (${now}) %c [${levels[level]}]`,
    'font-weight: bold; background-color: #00b89b; color: white;',
    `font-weight: bold; font-size: 12px;color: ${colors[level]}`,
  ]
  console.log(...args, ...msgs)
}

const debug = (...msgs: any[]) => {
  log(LevelEnum.DEBUG, ...msgs)
}

const info = (...msgs: any[]) => {
  log(LevelEnum.DEBUG, ...msgs)
  trace(LevelEnum.DEBUG, ...msgs)
}

const warn = (...msgs: any[]) => {
  log(LevelEnum.DEBUG, ...msgs)
  trace(LevelEnum.DEBUG, ...msgs)
}

const error = (...msgs: any[]) => {
  log(LevelEnum.ERROR, ...msgs)
  trace(LevelEnum.ERROR, ...msgs)
}

export default {
  debug,
  info,
  warn,
  error,
}
